import React, { forwardRef } from "react";
import "./mobile-input.css";

const MobileTextArea = React.memo(forwardRef(({ placeholder, name, required = false, value, onChange, label, rows = 3, disabled = false, ...props }, ref) => {
    return (
        <div className={`mobile-input-wrapper w-100 position-relative ${disabled ? 'is-disabled' : ''}`}>
            {label && <label className="mobile-input-label">{label}</label>}
            <div className="position-relative">
                <textarea
                    ref={ref}
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="mobile-input mobile-textarea shadow-none"
                    required={required}
                    rows={rows}
                    disabled={disabled}
                    {...props}
                />
            </div>
        </div>
    );
}));

MobileTextArea.displayName = 'MobileTextArea';

export default MobileTextArea;
